export default [
    {
        path: '/static/form/app/detail/',
        name: 'form-detail',
        component: () => import('views/modules/np/form/app/detail'),
        meta: {
            // parent: '/nforaaCode3946id1126099852240760832',
            icon: 'el-icon-document',
            title: '表单详情',
            path: '',
            isApp: false,
            isIframe: false,
            isLink: false,
            isAffix: false,
            isHide: false,
            params: {},
        },
    },
];
